/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_ErrorInputs */

const en_admin_user_list_mail_error = /** @type {(inputs: Admin_User_List_Mail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load recipients.`)
};

const de_admin_user_list_mail_error = /** @type {(inputs: Admin_User_List_Mail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfänger konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Could not load recipients." |
*
* @param {Admin_User_List_Mail_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_error = /** @type {((inputs?: Admin_User_List_Mail_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_error(inputs)
	return en_admin_user_list_mail_error(inputs)
});